import { collection, doc, getDocs, addDoc, updateDoc, query, where, orderBy, getFirestore } from 'firebase/firestore';
// import { db } from '../../config/firebase';
import { COLLECTIONS } from './collections';
import { Booking } from '../../types';

export const bookingsService = {
  async getAll(): Promise<Booking[]> {
    const db = getFirestore();
    const querySnapshot = await getDocs(
      query(collection(db, COLLECTIONS.BOOKINGS), orderBy('createdAt', 'desc'))
    );
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as Booking[];
  },

  async add(booking: Omit<Booking, 'id'>): Promise<string> {
    const db = getFirestore();
    const docRef = await addDoc(collection(db, COLLECTIONS.BOOKINGS), booking);
    return docRef.id;
  },

  async updateStatus(id: string, status: Booking['status']): Promise<void> {
    const db = getFirestore();
    await updateDoc(doc(db, COLLECTIONS.BOOKINGS, id), { status });
  },

  async getByDateAndTable(date: string, tableId: string): Promise<Booking[]> {
    const db = getFirestore();
    const q = query(
      collection(db, COLLECTIONS.BOOKINGS),
      where('date', '==', date),
      where('tableId', '==', tableId),
      where('status', 'in', ['pending', 'confirmed'])
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as Booking[];
  }
};
